import './App.css';
import logo from './assets/images/logo/MemroxLogo.svg';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className='logo' alt="Logo"/>
        <p>
          UNDER CONSTRUCTION...
        </p>
      </header>
    </div>
  );
}

export default App;
